// bps-cart-drawer.js
(function () {
  const root = document.getElementById('bps-cart-drawer');
  if (!root) return;

  const protectionVariantId = parseInt(root.dataset.protectionVariantId || '0', 10) || null;
  const bundleHandle = root.dataset.bundleHandle || null;
  const bundleLabel = root.dataset.bundleLabel || 'Item';
  const bundleMaxQty = parseInt(root.dataset.bundleMaxQty || '3', 10);

  const itemsEl = root.querySelector('.bpsc__items');
  const countEl = root.querySelector('.bpsc__footer-count');
  const savingsEl = root.querySelector('.bpsc__footer-savings');
  const subtotalEl = root.querySelector('.bpsc__footer-subtotal');
  const protectionToggle = root.querySelector('#bpsc-protection-toggle');

  const L = Object.assign({
    remove: 'Remove',
    eachPrefix: 'Only',
    eachSuffix: 'each',
    savePrefix: 'Save',
    upsellLabel: '★ UPGRADE & SAVE MORE',
    upsellAddPrefix: 'Add 1 more for',
    upsellEachPrefix: "It's only",
    upsellEachSuffix: 'each!',
    upsellSavePrefix: 'Save',
    upsellCta: 'SAVE MORE →'
  }, window.__bpscConfig?.labels || {});

  let productCache = {};

  function money(cents) {
    const symbol = window.__bpscConfig?.currencySymbol || '';
    return symbol + (cents / 100).toFixed(2);
  }

  async function fetchJSON(url, opts) {
    const res = await fetch(url, opts);
    if (!res.ok) throw new Error('Request failed: ' + url);
    return res.json();
  }

  async function getProduct(handle) {
    if (!handle) return null;
    if (productCache[handle]) return productCache[handle];
    try {
      const data = await fetchJSON(`/products/${handle}.js`);
      productCache[handle] = data;
      return data;
    } catch (e) {
      return null;
    }
  }

  function getBundlePrice(qty) {
    const q = Math.max(1, Math.min(qty, 3));
    return {
      was: parseFloat(root.dataset[`bundlePriceQty${q}Was`] || '0'),
      now: parseFloat(root.dataset[`bundlePriceQty${q}Now`] || '0')
    };
  }

  // ---------- Regular (non-bundle) line items ----------
  function renderItem(item) {
    const hasCompare = item.original_line_price > item.line_price;
    return `
      <div class="bpsc__item" data-line-key="${item.key}">
        <div class="bpsc__item-thumb"><img src="${item.image}" alt="${item.product_title}" loading="lazy"></div>
        <div class="bpsc__item-body">
          <div class="bpsc__item-title">${item.product_title}</div>
          <div class="bpsc__item-variant">×${item.quantity} ${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div class="bpsc__item-actions">
            <a data-action="edit">Edit</a>
            <a data-action="remove">${L.remove}</a>
          </div>
          <div class="bpsc__item-stepper" hidden>
            <button type="button" data-action="dec">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-action="inc">+</button>
          </div>
        </div>
        <div class="bpsc__item-price-col">
          ${hasCompare ? `<span class="bpsc__item-was">${money(item.original_line_price)}</span>` : ''}
          <span class="bpsc__item-now">${money(item.line_price)}</span>
        </div>
      </div>
    `;
  }

  // ---------- Bundle group (multi-pillow) card ----------
  function renderSwatches(variants, currentVariantId, slot) {
    return `
      <div class="bpsc__swatches" data-slot="${slot}">
        ${variants.map(v => {
          const imgSrc = v.featured_image && v.featured_image.src ? v.featured_image.src : '';
          return `
          <button type="button" class="bpsc__swatch ${v.id === currentVariantId ? 'bpsc__swatch--selected' : ''}"
                  data-variant-id="${v.id}" title="${v.title}">
            ${imgSrc ? `<img src="${imgSrc}" alt="${v.title}">` : ''}
          </button>
        `;
        }).join('')}
      </div>
    `;
  }

  function chunkBundleItems(items, maxQty) {
    const chunks = [];
    let current = [];
    let currentQty = 0;
    items.forEach(item => {
      if (currentQty + item.quantity > maxQty && current.length > 0) {
        chunks.push(current);
        current = [];
        currentQty = 0;
      }
      current.push(item);
      currentQty += item.quantity;
    });
    if (current.length > 0) chunks.push(current);
    return chunks;
  }

  async function renderBundleGroup(chunkItems, groupIndex) {
    const totalQty = chunkItems.reduce((sum, i) => sum + i.quantity, 0);
    if (totalQty === 0) return '';

    const first = chunkItems[0];

    if (totalQty === 1) {
      return `
        <div class="bpsc__item" data-line-key="${first.key}" data-bundle="1">
          <div class="bpsc__item-thumb"><img src="${first.image}" alt="${first.product_title}" loading="lazy"></div>
          <div class="bpsc__item-body">
            <div class="bpsc__item-title">${first.product_title}</div>
            <div class="bpsc__item-variant">×1 ${bundleLabel}</div>
            <div class="bpsc__item-actions">
              <a data-bundle-action="remove" data-key="${first.key}">${L.remove}</a>
            </div>
          </div>
          <div class="bpsc__item-price-col">
            <span class="bpsc__item-was">${money(getBundlePrice(1).was)}</span>
            <span class="bpsc__item-now">${money(first.line_price)}</span>
          </div>
        </div>
        ${await renderBundleUpsell(totalQty, first.image, groupIndex)}
      `;
    }

    const product = await getProduct(bundleHandle);
    const variants = product?.variants || [];
    const price = getBundlePrice(totalQty);
    const priceCents = { was: Math.round(price.was), now: Math.round(price.now) };
    const each = totalQty > 0 ? priceCents.now / totalQty : 0;
    const pct = priceCents.was > 0 ? Math.round(((priceCents.was - priceCents.now) / priceCents.was) * 100) : 0;
    const savingsAmount = priceCents.was - priceCents.now;

    const rows = chunkItems.map((item, idx) => `
      <div class="bpsc__pillow-row" data-key="${item.key}">
        <div class="bpsc__pillow-thumb"><img src="${item.image}" alt="${item.variant_title}"></div>
        <div class="bpsc__pillow-body">
          <div class="bpsc__pillow-label">${bundleLabel} ${idx + 1}: <span class="bpsc__pillow-variant">${item.variant_title}</span></div>
          ${variants.length > 1 ? renderSwatches(variants, item.variant_id, item.key) : ''}
        </div>
        <div class="bpsc__pillow-price">${money(each)}</div>
      </div>
    `).join('');

    return `
      <div class="bpsc__bundle-card" data-group-index="${groupIndex}">
        <div class="bpsc__bundle-header">
          <span class="bpsc__bundle-title">${first.product_title}</span>
          <span class="bpsc__bundle-qty-badge">×${totalQty} ${bundleLabel}s</span>
        </div>
        ${rows}
        <div class="bpsc__bundle-divider"></div>
        <div class="bpsc__bundle-summary">
          <a class="bpsc__bundle-remove" data-bundle-action="remove-all" data-group-index="${groupIndex}">${L.remove}</a>
          <div class="bpsc__bundle-summary-price">
            <span class="bpsc__bundle-was">${money(priceCents.was)}</span>
            <span class="bpsc__bundle-now">${money(priceCents.now)}</span>
          </div>
        </div>
        <div class="bpsc__bundle-summary-row2">
          <span class="bpsc__bundle-each">${L.eachPrefix} ${money(each)} ${L.eachSuffix}</span>
          ${savingsAmount > 0 ? `<span class="bpsc__bundle-save-pill">${L.savePrefix} ${money(savingsAmount)}</span>` : ''}
        </div>
      </div>
      ${await renderBundleUpsell(totalQty, first.image, groupIndex)}
    `;
  }

  async function renderBundleUpsell(currentQty, thumbImage, groupIndex) {
    if (currentQty >= bundleMaxQty) return '';
    const nextQty = currentQty + 1;
    const current = getBundlePrice(currentQty);
    const next = getBundlePrice(nextQty);
    const incremental = Math.round(next.now - current.now);
    const each = Math.round(next.now / nextQty);
    const savings = Math.round(next.was - next.now);

    return `
      <div class="bpsc__upsell" data-bundle-action="add-one" data-group-index="${groupIndex}">
        <div class="bpsc__upsell-thumb">
          ${thumbImage ? `<img src="${thumbImage}" alt="">` : ''}
          <span class="bpsc__upsell-plus">+</span>
        </div>
        <div class="bpsc__upsell-body">
          <div class="bpsc__upsell-label">★ UPGRADE & SAVE MORE</div>
          <div class="bpsc__upsell-title">Add 1 more for ${money(incremental)}</div>
          <div class="bpsc__upsell-sub">It's only ${money(each)} each! Save ${money(savings)}</div>
        </div>
        <span class="bpsc__upsell-cta">${L.upsellCta}</span>
      </div>
    `;
  }

  function renderFooter(cart) {
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
  }

  function initCountdown() {
    const el = document.getElementById('bpsc-countdown');
    const timeEl = document.getElementById('bpsc-countdown-time');
    if (!el || !timeEl) return;

    const durationSeconds = parseInt(el.dataset.durationSeconds || '600', 10) || 600;
    const storageKey = 'bpsc_countdown_end';
    let endTime = null;

    try {
      const stored = parseInt(sessionStorage.getItem(storageKey) || '0', 10);
      if (stored && stored > Date.now()) endTime = stored;
    } catch (err) {
      // sessionStorage can throw in restricted contexts (e.g. the theme editor preview iframe)
      console.warn('BPS Cart: sessionStorage unavailable, countdown will restart on reload', err);
    }

    if (!endTime) {
      endTime = Date.now() + durationSeconds * 1000;
      try { sessionStorage.setItem(storageKey, String(endTime)); } catch (err) { /* ignore */ }
    }

    function tick() {
      const diff = endTime - Date.now();
      if (diff <= 0) {
        el.hidden = true;
        clearInterval(timer);
        return;
      }
      const minutes = Math.floor(diff / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      timeEl.textContent = `${minutes}:${String(seconds).padStart(2, '0')}`;
    }

    tick();
    const timer = setInterval(tick, 1000);
  }
  try {
    initCountdown();
  } catch (err) {
    console.error('BPS Cart: countdown failed to start', err);
  }

  let protectionAutoAddAttempted = false;

  async function refresh() {
    const cart = await fetchJSON('/cart.js');

    if (protectionVariantId && !protectionAutoAddAttempted) {
      protectionAutoAddAttempted = true;
      const hasProtection = cart.items.some(i => i.variant_id === protectionVariantId);
      const defaultOn = root.dataset.protectionDefaultOn === 'true';
      if (defaultOn && !hasProtection) {
        await addItem(protectionVariantId, 1); // triggers its own refresh()
        return;
      }
    }

    const bundleItems = bundleHandle ? cart.items.filter(i => i.handle === bundleHandle) : [];
    const otherItems = bundleHandle ? cart.items.filter(i => i.handle !== bundleHandle) : cart.items;

    const emptyEl = root.querySelector('.bpsc__empty');
    const cartContentEl = root.querySelector('.bpsc__cart-content');
    const footerEl = root.querySelector('#bpsc-footer');

    if (cart.items.length === 0) {
      if (emptyEl) emptyEl.hidden = false;
      if (cartContentEl) cartContentEl.hidden = true;
      if (footerEl) footerEl.hidden = true;
      return;
    } else {
      if (emptyEl) emptyEl.hidden = true;
      if (cartContentEl) cartContentEl.hidden = false;
      if (footerEl) footerEl.hidden = false;
    }

    let html = '';
    const bundleChunks = bundleItems.length > 0 ? chunkBundleItems(bundleItems, bundleMaxQty) : [];
    if (bundleChunks.length > 0) {
      try {
        for (let i = 0; i < bundleChunks.length; i++) {
          html += await renderBundleGroup(bundleChunks[i], i);
        }
      } catch (err) {
        console.error('BPS Cart: bundle group render failed, falling back to plain items', err);
        html = bundleItems.map(renderItem).join('') + html;
      }
    }
    html += otherItems.map(renderItem).join('');

    if (itemsEl) {
      itemsEl.innerHTML = html || `<div style="text-align:center;color:#9a9a9a;font-size:13px;padding:20px 0;">Your cart is empty</div>`;
    }

    renderFooter(cart);

    if (protectionToggle && protectionVariantId) {
      const hasProtection = cart.items.some(i => i.variant_id === protectionVariantId);
      protectionToggle.checked = hasProtection;
    }

    wireItemActions(cart);
    wireBundleActions(cart, bundleItems, bundleChunks);
  }

  async function changeItem(key, quantity) {
    await fetchJSON('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    await refresh();
  }

  async function addItem(variantId, quantity, properties) {
    const payload = { id: variantId, quantity };
    if (properties) payload.properties = properties;
    await fetchJSON('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [payload] })
    });
    await refresh();
  }

  function wireItemActions(cart) {
    itemsEl?.querySelectorAll('.bpsc__item:not([data-bundle])').forEach(el => {
      const key = el.dataset.lineKey;
      const item = cart.items.find(i => i.key === key);
      if (!item) return;

      const editLink = el.querySelector('[data-action="edit"]');
      const removeLink = el.querySelector('[data-action="remove"]');
      const stepper = el.querySelector('.bpsc__item-stepper');
      const decBtn = stepper?.querySelector('[data-action="dec"]');
      const incBtn = stepper?.querySelector('[data-action="inc"]');

      editLink?.addEventListener('click', () => { if (stepper) stepper.hidden = false; });
      removeLink?.addEventListener('click', (e) => {
        e.preventDefault();
        changeItem(item.key, 0).catch(err => console.error('BPS Cart: remove failed', err));
      });
      decBtn?.addEventListener('click', () => {
        changeItem(item.key, Math.max(0, item.quantity - 1)).catch(err => console.error('BPS Cart: decrease failed', err));
      });
      incBtn?.addEventListener('click', () => {
        changeItem(item.key, item.quantity + 1).catch(err => console.error('BPS Cart: increase failed', err));
      });
    });

    root.querySelectorAll('.bpsc__addon-add').forEach(btn => {
      btn.onclick = () => addItem(parseInt(btn.dataset.variantId, 10), 1);
    });
  }

  function wireBundleActions(cart, bundleItems, bundleChunks) {
    // remove single (qty === 1 state)
    itemsEl?.querySelectorAll('[data-bundle-action="remove"]').forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        changeItem(el.dataset.key, 0).catch(err => console.error('BPS Cart: bundle remove failed', err));
      });
    });

    // remove all lines within a specific group/chunk
    itemsEl?.querySelectorAll('[data-bundle-action="remove-all"]').forEach(el => {
      el.addEventListener('click', async (e) => {
        e.preventDefault();
        const groupIndex = parseInt(el.dataset.groupIndex, 10);
        const chunk = bundleChunks[groupIndex];
        if (!chunk) return;
        try {
          for (const item of chunk) {
            const res = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            });
            if (!res.ok) {
              const errBody = await res.text();
              throw new Error(`cart/change.js failed (${res.status}): ${errBody}`);
            }
          }
          await refresh();
        } catch (err) {
          console.error('BPS Cart: bundle remove-all failed', err);
        }
      });
    });

    // upsell: add one more pillow to a specific group (default variant, unique slot)
    itemsEl?.querySelectorAll('[data-bundle-action="add-one"]').forEach(el => {
      el.addEventListener('click', async () => {
        const groupIndex = parseInt(el.dataset.groupIndex, 10);
        const chunk = bundleChunks[groupIndex];
        try {
          const defaultVariant = chunk?.[0]?.variant_id;
          if (!defaultVariant) return;
          const nextSlot = 'u' + Date.now() + Math.random().toString(36).slice(2, 6);
          await addItem(defaultVariant, 1, { '_bps_slot': nextSlot, '_bps_bundle': bundleHandle });
        } catch (err) {
          console.error('BPS Cart: add one more failed', err);
        }
      });
    });

    // color swap per pillow row (lookup by key works across the flat list regardless of chunk)
    itemsEl?.querySelectorAll('.bpsc__swatch').forEach(sw => {
      sw.addEventListener('click', async (e) => {
        e.preventDefault();
        const row = sw.closest('.bpsc__pillow-row');
        const oldKey = row?.dataset.key;
        const newVariantId = parseInt(sw.dataset.variantId, 10);
        if (!oldKey || !newVariantId) return;
        const oldItem = bundleItems.find(i => i.key === oldKey);
        const slot = oldItem?.properties?._bps_slot || '1';
        try {
          await fetchJSON('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: oldKey, quantity: 0 })
          });
          await addItem(newVariantId, 1, { '_bps_slot': slot, '_bps_bundle': bundleHandle });
        } catch (err) {
          console.error('BPS Cart: color swap failed', err);
        }
      });
    });
  }

  protectionToggle?.addEventListener('change', async () => {
    if (!protectionVariantId) return;
    if (protectionToggle.checked) {
      await addItem(protectionVariantId, 1);
    } else {
      await changeItem(protectionVariantId, 0);
    }
  });

  root.querySelector('.bpsc__addons-more')?.addEventListener('click', function () {
    root.querySelectorAll('.bpsc__addon-extra').forEach(el => { el.hidden = false; });
    this.hidden = true;
  });

  root.querySelector('#bpsc-checkout')?.addEventListener('click', () => {
    window.location.href = '/checkout';
  });

  root.querySelectorAll('[data-bpsc-close]').forEach(el => {
    el.addEventListener('click', close);
  });

  function open() {
    root.hidden = false;
    requestAnimationFrame(() => root.classList.add('bpsc--open'));
    document.documentElement.classList.add('overflow-hidden');
    refresh();
  }

  function close() {
    root.classList.remove('bpsc--open');
    document.documentElement.classList.remove('overflow-hidden');
    setTimeout(() => { root.hidden = true; }, 280);
  }

  document.addEventListener('keyup', (e) => { if (e.key === 'Escape') close(); });

  // Take over the theme's own cart icon so it opens our drawer instead of the native one.
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('#cart-icon-bubble, a[href="/cart"], [data-cart-icon], .header__icon--cart, cart-icon-bubble');
    if (trigger && !root.contains(trigger)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      open();
    }
  }, true);

  window.BPSCart = { open, close, refresh };
})();
